import React from 'react';
import { TableCell, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { CollectorSettingScope } from 'graphql/types';

type ScopedCellProps = {
  scope: CollectorSettingScope;
  userText: string;
  tenantText: string;
};

export const ScopedCell: React.FC<ScopedCellProps> = ({
  scope,
  userText,
  tenantText
}: ScopedCellProps) => {
  return (
    <TableCell>
      <Typography>
        {scope === CollectorSettingScope.Tenant ? (
          <FormattedMessage id={tenantText} />
        ) : (
          <FormattedMessage id={userText} />
        )}
      </Typography>
    </TableCell>
  );
};
export default React.memo(ScopedCell);
